import { Link } from 'react-router-dom';

import Button from '../components/ui/Button';
import Reveal from '../components/ui/Reveal';
import { FREE_TRIAL_MESSAGE, SITE, whatsappLink } from '../config/site';

export default function FinalCta() {
    return (
        <section className="section-y">
            <div className="container">
                <Reveal>
                    <div className="relative overflow-hidden rounded-3xl border border-line-brand bg-brand/[0.06] px-6 py-14 text-center sm:px-12">
                        <div
                            className="pointer-events-none absolute inset-0 -z-10"
                            aria-hidden="true"
                        >
                            <div className="absolute left-1/2 top-0 h-64 w-[32rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/10 blur-[100px]" />
                        </div>

                        <h2 className="mx-auto max-w-2xl text-heading font-bold text-white text-balance">
                            Prêt à profiter de {SITE.name} dès ce soir ?
                        </h2>
                        <p className="mx-auto mt-4 max-w-xl text-lead text-content-muted text-pretty">
                            Commandez en quelques minutes et recevez vos accès par e-mail. Ou commencez
                            par un test gratuit de 24 h, sans carte bancaire.
                        </p>

                        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                            <Button as={Link} to="/#forfaits" size="lg" className="w-full sm:w-auto">
                                Choisir mon forfait
                            </Button>
                            <Button
                                href={whatsappLink(FREE_TRIAL_MESSAGE)}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="outline"
                                size="lg"
                                className="w-full sm:w-auto"
                            >
                                Test gratuit 24 h
                            </Button>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
